import EmptyStateIcon from "../../src/assets/svg/emptyState.svg";

export interface EmptyStateProps {
  title: string;
  message: string;
}

export function EmptyState(props: EmptyStateProps) {
  return (
    <div className="flex flex-col gap-3">
      <div>
        <img src={EmptyStateIcon} alt="Empty paper"></img>
      </div>
      <div className="flex flex-col gap-2">
        <h2 className="text-lg font-medium uppercase text-gray-extra-dark">
          {props.title}
        </h2>
        <p className="text-[15px] text-gray-extra-dark text-opacity-80">
          {props.message}
        </p>
      </div>
    </div>
  );
}

export default EmptyState;
